/* 分类api */
const api = {
  // 根据分类id分类等级获取分类列表  id level
  categoryList: '/webApi/category/getCateGoryByLevel',
  getCateGoryByLevelAndSchoolIdApi: '/webApi/category/getCateGoryByLevelAndSchoolId',
  ebookList: '/webApi/book/searchBookList',
  ebookTypeList: '/webApi/dictData/getInfo',
};

export default api;
